import React from 'react'
import './ContactFile.css'
const ContactForm = () => {
  return (
    <div className='from-container'>
      <h1>Send a message to us! </h1>
      <form>
        <input placeholder='name'/>
        <input placeholder='Email US'/>
        <input placeholder='Subject'/>
        <textarea placeholder='Message' row='4'></textarea>
        <button>Send Message</button>
      </form>
    </div>
  )
}

export default ContactForm
